module.exports = __webpack_public_path__ + "static/media/ai.7b4552df.svg";